export class DownloadInvoices {
    AccountOfficeCode: string;
    BookingDateFrom: Date;
    BookingDateTo: Date;
    AirAsiaRef: string;
    InvoiceDate: Date;
    InvoiceNumber: string;
    ExportFileType: string;
}

export class DownloadOthInvoices {
    AccountOfficeCode: string;
    BookingDateFrom: Date;
    BookingDateTo: Date;
    AirAsiaRef: string;
    InvoiceNo: string;
    InvoiceDate: Date;
    ExportFileType: string;
    AccountNo: string;
    AaAccount: string;
    WarrantNo: string;
}